import { combineReducers } from 'redux';

import { State as StateAccess, access } from 'src/reducers/access';
import { State as StateAnalytics, analytics } from 'src/reducers/analytics';
import { State as StateBrand, brand } from 'src/reducers/brand';
import {
  State as StateCurrentActiveActions,
  currentActiveActions,
} from 'src/reducers/currentActiveActions';
import {
  State as StateInfluencers,
  influencers,
} from 'src/reducers/influencers';
import { State as StateModals, modals } from 'src/reducers/modals';
import {
  State as StateNotifications,
  notifications,
} from 'src/reducers/notifications';
import {
  State as StateOrganization,
  organization,
} from 'src/reducers/organization';
import { State as StatePool, pool } from 'src/reducers/pool';
import { State as StateSequences, sequences } from 'src/reducers/sequences';
import { State as StateSidebar, sidebars } from 'src/reducers/sidebar';
import { State as StateTags, tags } from 'src/reducers/tags';
import { State as StateUsers, users } from 'src/reducers/users';

//import { State as StateTodo, todo } from 'src/reducers/todo';

export interface ReduxState {
  access: StateAccess;
  analytics: StateAnalytics;
  influencers: StateInfluencers;
  currentActiveActions: StateCurrentActiveActions;
  tags: StateTags;
  sidebar: StateSidebar;
  notifications: StateNotifications;
  organization: StateOrganization;
  modals: StateModals;
  pool: StatePool;
  brand: StateBrand;
  sequences: StateSequences;
  users: StateUsers;
}

export const initialState = {
  access: access.initialState,
  analytics: analytics.initialState,
  influencers: influencers.initialState,
  currentActiveActions: currentActiveActions.initialState,
  tags: tags.initialState,
  sidebar: sidebars.initialState,
  notifications: notifications.initialState,
  organization: organization.initialState,
  modals: modals.initialState,
  pool: pool.initialState,
  brand: brand.initialState,
  sequences: sequences.initialState,
  users: users.initialState,
};

export const rootReducer = combineReducers<ReduxState>({
  access: access.reducer,
  analytics: analytics.reducer,
  influencers: influencers.reducer,
  currentActiveActions: currentActiveActions.reducer,
  tags: tags.reducer,
  sidebar: sidebars.reducer,
  notifications: notifications.reducer,
  organization: organization.reducer,
  modals: modals.reducer,
  pool: pool.reducer,
  brand: brand.reducer,
  sequences: sequences.reducer,
  users: users.reducer,
});
